import React, { useEffect, useMemo } from 'react';
import { getIndustryConfetti } from '../utils/industryConfettiConfig';

/**
 * Industry-specific confetti celebration component
 * Displays themed icons that match the business niche
 */
export default function IndustryConfetti({ naicsCode, customIcons, show, onComplete }) {
  const confettiIcons = useMemo(() => {
    if (customIcons?.length > 0) {
      return customIcons;
    }
    return getIndustryConfetti(naicsCode);
  }, [naicsCode, customIcons]);
  const confettiCount = 60;

  React.useEffect(() => {
    if (show && onComplete) {
      const timer = setTimeout(() => {
        onComplete();
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [show, onComplete]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-50">
      {[...Array(confettiCount)]?.map((_, i) => {
        const iconConfig = confettiIcons?.[i % confettiIcons?.length];
        const IconComponent = iconConfig?.icon;
        const animationVariant = (i % 5) + 1;
        const shapeType = i % 3; // 0: circle, 1: square, 2: triangle
        
        let animationClass = '';
        if (shapeType === 0) {
          animationClass = `animate-confetti-${animationVariant}`;
        } else if (shapeType === 1) {
          animationClass = `animate-confetti-square-${animationVariant}`;
        } else {
          animationClass = `animate-confetti-triangle-${animationVariant}`;
        }
        
        return (
          <div
            key={i}
            className={`absolute ${animationClass}`}
            style={{
              left: `${Math.random() * 100}%`,
              top: '-5%',
              animationDelay: `${Math.random() * 0.5}s`
            }}
          >
            <IconComponent
              className="w-6 h-6"
              style={{ color: iconConfig?.color }}
              strokeWidth={2}
            />
          </div>
        );
      })}
    </div>
  );
}